//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import FilterButton from '../../../../../elements/HorizontalFilter/FilterButton/FilterButton';
import {useBlogCategories} from '../../../utils/blog-category';
import {
  useBlogPostFilter,
  useBlogPostFilterActions,
} from '../../../utils/blog-post';

const useStyles = makeStyles(theme => ({
  filterSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '1rem',
    gap: '.5rem',
  },
  filterChipContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  filterList: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    marginTop: '.5rem',
  },
}));

export default function BlogFilter() {
  const classes = useStyles();

  const categories = useBlogCategories();
  const filters = useBlogPostFilter();
  const {setBlogPostCategories} = useBlogPostFilterActions();

  const resetFilter = () => {
    setBlogPostCategories([]);
  };

  const selectedFilter = filters?.categories || [];

  const toggleFilter = (filter: string) => {
    if (selectedFilter.includes(filter)) {
      setBlogPostCategories(selectedFilter.filter(f => f !== filter));
    } else {
      setBlogPostCategories([...selectedFilter, filter]);
    }
  };

  return (
    <div className={classes.filterSection}>
      <div className={classes.filterChipContainer}>
        <span>Filtrar por:</span>
        <div className={classes.filterList}>
          <FilterButton
            id="all"
            handleOnClick={() => {
              resetFilter();
            }}
            text="todos"
            selected={selectedFilter.length === 0}
          />

          {categories.map((category, index: number) => (
            <FilterButton
              key={category.id}
              selected={selectedFilter.includes(category.id)}
              id={category.id}
              handleOnClick={() => {
                toggleFilter(category.id);
              }}
              text={category.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
